import React, {useState, useEffect} from 'react';
import { Pie } from 'src/mtska-frontend-app-component';
import { Box } from '@mui/joy';
import { useTranslation } from 'react-i18next';
import { useSettingContextInComponent, useSettingsContext } from "src/mtska-frontend-app-scaffolding";
import JSONPretty from 'react-json-pretty'

const PieSet = ({ dataProviderName, filters: defaultFilters }) => {
    const { t } = useTranslation();
    const { addFilter } = useSettingsContext(dataProviderName);
    const { filterModel, drawable } = useSettingContextInComponent(dataProviderName, defaultFilters);
    const [localDrawable, setLocalDrawable] = useState();
    const [localFilterModel, setLocalFilterModel] = useState();

    useEffect(() => {
        if (!filterModel) return;
        const localFilterModel = { items:[...filterModel.items, {field:"status", operator:"equals", value:"accepted"}]}
        setLocalFilterModel(localFilterModel);
        setLocalDrawable(true);
    },[filterModel])

    const createSliceFilterHandler = (field, addFilter) => (params) => {
        addFilter(field, params);
    };

    return (localDrawable &&
        <Box className="report-itemgroup">
            <Box className="report-itemrow">
                {/* COMMENTATO SOLO PER TEMA DI IMPAGINAZIONE
                <Box className="report-item">
                    <Pie
                        title={t("Accepted by Area")}
                        dataProviderName={"statisticsviews/acceptedperarea/aggregated/views_opportunities_proposal/_related_area_name"}
                        filters={localFilterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_area_name', addFilter)}
                    />
                </Box> 
                */}
                <Box className="report-item">
                    <Pie
                        title={t("Accepted by Shop")}
                        dataProviderName={"statisticsviews/acceptedpershop/aggregated/views_opportunities_proposal/_related_shop_name"}
                        filters={localFilterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_shop_name', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Accepted by Buyer Agent")}
                        dataProviderName={"statisticsviews/acceptedperagent/aggregated/views_opportunities_proposal/_related_buyerAgent_fullname"}
                        filters={localFilterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_buyerAgent_fullname', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Accepted by Seller Agent")}
                        dataProviderName={"statisticsviews/acceptedperagent/aggregated/views_opportunities_proposal/_related_sellerAgent_fullname"}
                        filters={localFilterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_sellerAgent_fullname', addFilter)}
                    />
                </Box>
            </Box>
            <Box className="report-itemrow">
                <Box className="report-item">
                    <Pie
                        title={t("Accepted by Source")}
                        dataProviderName={"statisticsviews/acceptedpersource/aggregated/views_opportunities_proposal/_related_source_name"}
                        filters={localFilterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('_related_source_name', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Accepted by Status")}
                        dataProviderName={"statisticsviews/acceptedpersource/aggregated/views_opportunities_proposal/status"}
                        filters={localFilterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('status', addFilter)}
                    />
                </Box>
                <Box className="report-item">
                    <Pie
                        title={t("Accepted by Product")}
                        dataProviderName={"statisticsviews/acceptedpersource/aggregated/views_opportunities_proposal/product"}
                        filters={localFilterModel}
                        showTotal={false}
                        handleFilterChange={createSliceFilterHandler('product', addFilter)}
                    />
                </Box>
            </Box>
        </Box>
    )
}

export default PieSet;